import { forwardRef } from 'react';
import styled from 'styled-components';

import { colors } from 'styles/theme/colors';

interface DragHandleIconProps {
  fill?: string;
  size?: number;
}

function DragHandleIcon({ fill = colors.black25, size = 16 }: DragHandleIconProps) {
  return (
    <svg width={size} height={size} viewBox='0 0 16 16' fill='none'>
      <rect x='2' y='2' width='12' height='1.5' rx='0.75' fill={fill} />
      <rect x='2' y='5.5' width='12' height='1.5' rx='0.75' fill={fill} />
      <rect x='2' y='9' width='12' height='1.5' rx='0.75' fill={fill} />
      <rect x='2' y='12.5' width='12' height='1.5' rx='0.75' fill={fill} />
    </svg>
  );
}

const DragHandle = forwardRef<HTMLDivElement>((props, ref) => (
  <Wrapper ref={ref} {...props}>
    <DragHandleIcon />
  </Wrapper>
));

DragHandle.displayName = 'DragHandle';

export default DragHandle;

const Wrapper = styled.div`
  cursor: grab;
  display: flex;
  align-items: center;
  padding: 4px;
  touch-action: none;

  &:active {
    cursor: grabbing;
  }
`;
